import React from 'react';

export const handleCopyEvents = (e: React.ClipboardEvent<HTMLElement>, role: string, is_user_pro: boolean) => {
  console.log('Per Vinous Terms of Service, copy/cut of tasting notes is prohibited.');
  if (role !== "publisher") {
    stopEventPropogation(e);
  }
};

const stopEventPropogation = (e: React.ClipboardEvent<HTMLElement>) => {
  e.preventDefault();
  e.nativeEvent.stopImmediatePropagation();
}
